export enum SystemRolesEnum {
    Admin = 0,
    Player = 1,
    Partner = 2
}